(function () {
  function init(root) {
    if (!root || root.dataset.iqInit === '1') return;
    root.dataset.iqInit = '1';

    var form = root.querySelector('form');
    if (!form || !form.id) return;

    var choice = document.getElementById(form.id + '-charger-choice');
    var modelWrap = document.getElementById(form.id + '-charger-model-wrap');

    if (!choice || !modelWrap) return;

    function update() {
      var v = (choice.value || '').trim();
      if (!v) {
        modelWrap.style.display = 'none';
        return;
      }
      modelWrap.style.display = (v.indexOf('Ναι') === 0) ? 'block' : 'none';
    }

    choice.addEventListener('change', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-iq-form]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', initAll);

  window.IQFormInitAll = initAll;
})();

(function () {
  function patchDialog(dlg) {
    if (!dlg || dlg.dataset.iqShowModalPatched === "1") return;
    dlg.dataset.iqShowModalPatched = "1";

    var orig = dlg.showModal;
    if (typeof orig !== "function") return;

    dlg.showModal = function (opener, processTemplate) {
      // Lock width BEFORE the template content is appended (processBodyContent)
      if (processTemplate === true) {
        var box = this.querySelector(".js-dialog-container");
        if (box && !box.dataset.iqWidthLocked) {
          var w = box.getBoundingClientRect().width; // original width (before injection)
          if (w > 0) {
            box.style.maxWidth = w + "px";
            box.dataset.iqWidthLocked = "1";
          }
        }
      }
      return orig.call(this, opener, processTemplate);
    };
  }

  function init() {
    // Only popup-content dialogs have IDs like dialogPopupContent...
    document.querySelectorAll('sht-dialog[id^="dialogPopupContent"]').forEach(patchDialog);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Theme editor
  document.addEventListener("shopify:section:load", init);
})();

document.addEventListener('opened', function () {
  if (window.IQFormInitAll) window.IQFormInitAll();
}, true);

(function () {
  function getTitle(el) {
    return (el && el.getAttribute('data-installation-quote-title')) || '';
  }

  // Click handler (delegated, survives cart re-renders)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-installation-quote-trigger]');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    if (typeof window.openInstallationQuotePopup === 'function') {
      window.openInstallationQuotePopup(trigger, getTitle(trigger));
    } else {
      console.log('openInstallationQuotePopup not found');
    }
  }, true);

  // Keyboard accessibility (Enter/Space)
  document.addEventListener('keydown', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-installation-quote-trigger]');
    if (!trigger) return;

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();

      if (typeof window.openInstallationQuotePopup === 'function') {
        window.openInstallationQuotePopup(trigger, getTitle(trigger));
      }
    }
  }, true);
})();
